// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountDetailsStyles from "@awc/App/SharedStyles/MyAccountDetailsStyles";
import { rfqQuoteDetailsHeaderStyles } from "@awc/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsHeader";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, xScreen } from "@awc/XDL/Utilities";
import { StyledTypography } from "@insite/mobius/Link";
import { css } from "styled-components";

rfqQuoteDetailsHeaderStyles.headerGridContainer = {
    gap: 0,
};

rfqQuoteDetailsHeaderStyles.title = {
    variant: "h3",
    as: "h1",
    css: css`
        @media print {
            font-size: 11px;
        }
    `,
};

rfqQuoteDetailsHeaderStyles.buttonGridItem = {
    width: 12,
    css: css`
        gap: 16px 24px;
        flex-wrap: wrap;
        &&& {
            margin-top: 10px;
            justify-content: end;
        }
        &.buttons-center {
            justify-content: center;
        }
    `,
};

rfqQuoteDetailsHeaderStyles.printButton = {
    variant: "primary",
    css: css`
        @media Print {
            display: none;
        }
    `,
};

rfqQuoteDetailsHeaderStyles.declineQuoteButton = {
    variant: "secondary",
};

rfqQuoteDetailsHeaderStyles.deleteQuoteButton = {
    variant: "primary",
    css: css`
        margin-left: 10px;
    `,
};

rfqQuoteDetailsHeaderStyles.submitQuoteButton = { variant: "tertiary" };
